import script from "./NavigationItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationItem.vue?vue&type=script&setup=true&lang=js"

import "./NavigationItem.vue?vue&type=style&index=0&id=2ece67d4&scoped=true&lang=css"
import "./NavigationItem.vue?vue&type=style&index=1&id=2ece67d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ece67d4"]])

export default __exports__